module.exports = __webpack_public_path__ + "static/media/pla_vel_tur.2ea9a13a.png";